import React from 'react';

interface GatherContentMigrationHelperProps {
  blok: {
    markup: string;
  }
  slot: string;
}

export const GatherContentMigrationHelper = (
  { blok, slot }: GatherContentMigrationHelperProps,
): JSX.Element => (
  <roche-richtext
    type="richtext"
    slot={slot}
    dangerouslySetInnerHTML={{ __html: blok.markup }}
  >
  </roche-richtext>
);
